import styled, { css } from 'styled-components';
export const List = styled.ul `
  display: flex;
  list-style: none;
  padding: 0;

  & > * + * {
    margin-left: var(--space-200);
  }
`;
export const ItemButton = styled.button.attrs({
    type: 'button',
}) `
  display: flex;
  align-items: center;
  border-radius: 16px;
  outline: none;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-400);
  color: var(--text-secondary);

  ${({ $size }) => $size === 'small' &&
    css `
      padding: 0 var(--space-200);
      height: 24px;
    `};

  ${({ $size }) => $size === 'regular' &&
    css `
      padding: 0 var(--space-400);
      height: 32px;
    `};

  ${({ $isActive }) => $isActive &&
    css `
      background: var(--text-primary);
      color: var(--text-primary-invert);
      pointer-events: none;
    `};

  ${({ $isActive }) => !$isActive &&
    css `
      &:hover {
        background: var(--bg-secondary);
      }
    `};
`;
